import axios from "axios";
import React, { useState, useRef, useEffect } from "react";
import { Button, Col, Container, Row, Form, Spinner } from "react-bootstrap";
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select'
import { useSelector } from 'react-redux';


function AddMedia() {
  const [filePath, setFilePath] = useState(null)
  const [ltCampGrp, setLtCampGrp] = useState([])
  const [ltMediaType, setLtMediaType] = useState([])
  const [ltLang, setLtLang] = useState([])
  const [addLoadingMedia, setAddLoadingMedia] = useState(false)
  const [uploaded, setUploaded] = useState(false)
  const [selectedFile, setSelectedFile] = useState("")
  const [mediaValidation, setMediaValidation] = useState({
    name: null,
    width: null,
    height: null,
    path: null,
    language: null,
    campaign: null,
  })
  const [mediaFilter, setMediaFilter] = useState({
    name: "",
    width: 0,
    height: 0,
    type: 0,
    path: "",
    campaign: 0,
    language: 0
  })
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [affliatePermission, setAffliatePermission] = useState(false)
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    setUploaded(false)
    const file = event.target.files[0];
    if (file)
      setSelectedFile(file.name)
    const formData = new FormData();
    formData.append('image', file);
    try {
      const response = await axios.post(window.__CFG.API + "marketing/UploadMediaThumb", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": "Bearer " + localStorage.getItem("raff-token")

        },
      });
      if (response.data.Error === null) {
        setUploaded(true)
        setMediaFilter({ ...mediaFilter, path: response.data.File })

      }

    } catch (error) {
    }
  };
  const saveMedia = async () => {
    var initvalidation = {
      name: null,
      width: null,
      height: null,
      path: null,
      language: null,
      campaign: null,
    }
    var errored = false
    if (mediaFilter.name === "") {
      initvalidation.name = " Media name is required "
      errored = true
    }
    if (mediaFilter.width === 0) {
      initvalidation.width = " Media width is required "
      errored = true
    }
    if (mediaFilter.height === 0) {
      initvalidation.height = " Media height is required "
      errored = true
    }
    if (mediaFilter.path === "") {
      initvalidation.path = " Media path  is required "
      errored = true
    }

    setMediaValidation(initvalidation)
    if (errored) return;
    setAddLoadingMedia(true)
    const response = await axios.post(window.__CFG.API + "marketing/AddMedia", mediaFilter, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error == null) {
      toast.success("Updated Sucessufully", {
        duration: 4000
      });
      setMediaFilter({
        name: "",
        width: 0,
        height: 0,
        type: 0,
        path: "",
        campaign: 0,
        language: 0
      })
      setUploaded(false)
      setSelectedFile("")
    }
    else {
      toast.error("Update Error !!!", {
        duration: 4000
      });
    }
    setAddLoadingMedia(false)

  }
  const getListCompaigns = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllCampaigns", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtCampGrp(response.data.Result)
    }
  }
  const getListMediaType = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllMediaTypes", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtMediaType(response.data.Result)
    }
  }
  const getListLanguages = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllLanguages", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtLang(response.data.Result)
    }
  }
  useEffect(() => { setAffliatePermission(checkPermission(affliate, "mkt_create_media")) }, [affliate])
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  useEffect(() => { getListCompaigns(); getListMediaType(); getListLanguages() }, [])
  return (
    <>
      <Container>
        <Row>
          <Col>
            <h4 className="text-start mt-5">Create new media</h4>

            <Row className="justify-content-start mt-4 me-auto w-100 gap-5">
              <Col lg={5} md={4} sm={5}>
                <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                  <label>media name</label>
                </div>
                {
                  mediaValidation.name !== null ? (
                    <div class="invalid-feedback loginForm">
                      {mediaValidation.name}
                    </div>
                  ) : (
                    <></>
                  )
                }
                <Form.Control disabled={!affliatePermission} style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", width: "100%", padding: 4 }} type="text" onChange={(e) => { setMediaFilter({ ...mediaFilter, name: e.target.value }) }} value={mediaFilter.name} />
              </Col>
              <Col lg={5} md={4} sm={5}>
                <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                  <label> Size</label>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Form.Control disabled={!affliatePermission} style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", width: "100%", padding: 4 }} type="text" placeholder="width" onChange={(e) => { setMediaFilter({ ...mediaFilter, width: e.target.value }) }} value={mediaFilter.width} />
                  {
                    mediaValidation.width !== null ? (
                      <div class="invalid-feedback loginForm">
                        {mediaValidation.width}
                      </div>
                    ) : (
                      <></>
                    )
                  }
                  <div style={{ padding: 3 }}>X</div>
                  <Form.Control disabled={!affliatePermission} style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", width: "100%", padding: 4 }} type="text" placeholder="height" onChange={(e) => { setMediaFilter({ ...mediaFilter, height: e.target.value }) }} value={mediaFilter.height} />
                  {
                    mediaValidation.height !== null ? (
                      <div class="invalid-feedback loginForm">
                        {mediaValidation.height}
                      </div>
                    ) : (
                      <></>
                    )
                  }
                </div>

              </Col>
            </Row>

            <Row className="justify-content-start mt-4 me-auto w-100 gap-5">
              <Col lg={5} md={4} sm={5}>
                <div className='form-aff-list-in'>
                  <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                    <label>media type</label>
                  </div>
                  <div className="dashboard-select-periode" style={{ maxWidth: "100%" }} >
                    <Select isDisabled={!affliatePermission} options={ltMediaType} onChange={(e) => { setMediaFilter({ ...mediaFilter, type: e.value }) }} />

                  </div>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-start  mt-4  w-100 mb-5">

              <Col lg={5} md={4} sm={5} className=" md-se-btn">
                <Button disabled={!affliatePermission} onClick={handleButtonClick} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                  Select file
                </Button>
              </Col>
              {selectedFile != "" ? (<>
                <div style={uploaded ? { color: "green" } : { color: "red" }}>
                  {selectedFile}
                </div>
              </>) : (<></>)}
              {
                mediaValidation.path !== null ? (
                  <div class="invalid-feedback loginForm">
                    {mediaValidation.path}
                  </div>
                ) : (
                  <></>
                )
              }
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </Row>
            <Row
              className="justify-content-start  align-items-center me-auto w-100"
              style={{ marginTop: "50px" }}
            >
              <Col lg={4} md={4} sm={4}>
                <div className='form-aff-list-in'>
                  <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                    <label>campaign</label>
                  </div>
                  <div className="dashboard-select-periode" style={{ maxWidth: "100%" }} >
                    <Select isDisabled={!affliatePermission} options={ltCampGrp} onChange={(e) => { setMediaFilter({ ...mediaFilter, campaign: e.value }) }} />
                  </div>
                </div>
              </Col>
              <Col lg={3} md={4} sm={5}>
                <div className='form-aff-list-in'>
                  <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                    <label>language</label>
                  </div>
                  <div className="dashboard-select-periode" style={{ maxWidth: "100%" }} >
                    <Select isDisabled={!affliatePermission} options={ltLang} onChange={(e) => { setMediaFilter({ ...mediaFilter, language: e.value }) }} />
                  </div>
                </div>
                {
                  mediaValidation.language !== null ? (
                    <div class="invalid-feedback loginForm">
                      {mediaValidation.language}
                    </div>
                  ) : (
                    <></>
                  )
                }
              </Col>
            </Row>
            <Row className="justify-content-start  mt-4  w-75 mb-5">
              <Col lg={5} md={4} sm={5} className="mb-5 md-se-btn">
                <Button disabled={!affliatePermission || addLoadingMedia} onClick={saveMedia} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                  {addLoadingMedia ? (<> <Spinner size="sm"></Spinner></>) : (<>
                    Save

                  </>)}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AddMedia;
